//############################################################################
// Calc data
//############################################################################

// Loan limits and term rules live in one JSON file, shared with Twig
// (templates/_macros/calc.twig renders the starting figures server-side) and
// with the public /calculator.json feed.
import calcLimits from '../../../templates/_data/calculator-limits.json'

// Term range for a loan amount: the last band whose fromAmount is <= amount
export function termBandFor(amount) {
    let band = calcLimits.termBands[0];
    for (let i = 0; i < calcLimits.termBands.length; i++) {
        if (+amount >= calcLimits.termBands[i].fromAmount) {
            band = calcLimits.termBands[i];
        }
    }
    return band;
}

export const calcData = {
    defaultLoanTerm: calcLimits.defaultLoanTerm,
    loanValue: calcLimits.defaultLoanValue,
    loanSliderValue: 0,
    prevLoanValue: 0,
    minLoanValue: calcLimits.minLoanValue,
    maxLoanValue: calcLimits.maxLoanValue,
    loanIncrement: calcLimits.loanIncrement,
    buttonLink: "",
    enquiryUrl: "",
    queryStr: "",
    minTerm: calcLimits.minTerm,
    maxTerm: calcLimits.maxTerm,
    loanTerm: 0,
    prevLoanTerm: 0,
    termSliderValue: calcLimits.minTerm,
    apr: 0.1,
    monthlyRepaymentAmount: 0,
    totalRepayableAmount: 0,
}
